import { APIError, Logger, type TerrosHeaderMetadata } from '@terros/common'
import type { BackendContextType } from './BackendContext'

const logger = new Logger('api-core')

type Props = {
  backend: BackendContextType
  fullURL: string
  input: unknown
  additionalHeaders: TerrosHeaderMetadata | undefined
}

export async function getRequestOptions({ backend, fullURL, input, additionalHeaders }: Props): Promise<RequestInit> {
  if (!backend.isAuthenticated()) {
    throw new APIError({
      type: 'error',
      error: 'NotAuthorized',
      message: 'You are not authenticated',
      retry: false,
    })
  }

  const token = await backend.getToken()
  if (!token) {
    throw new APIError({
      type: 'error',
      error: 'NotAuthorized',
      message: 'Your token is empty',
      retry: false,
    })
  }

  const impersonating = backend.getImpersonating()

  const headers: Record<string, string> = {
    ...additionalHeaders,
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
  }

  if (impersonating) headers.impersonate_user_id = impersonating

  logger.info(`POST to ${fullURL} ${JSON.stringify(input)} Impersonating: ${JSON.stringify(impersonating)}`)

  const options: RequestInit = {
    method: 'POST',
    headers,
    body: JSON.stringify(input || '{}'),
  }

  logger.verbose(`with options ${JSON.stringify(options, null, 2)}`)
  return options
}
